import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAppointmentById } from '../../services/appointments';
import { Appointment } from '../../interfaces';

function useGetAppointment(
  appointmentId: string | null,
  options: Partial<UseQueryOptions<Appointment, Error>> & {
    onSuccess?: (data: Appointment) => void;
  } = {},
) {
  const isEnabled = !!appointmentId;
  const enabled = isEnabled && (options.enabled ?? true);

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    isPlaceholderData,
  } = useQuery({
    queryKey: ['appointment', appointmentId],
    queryFn: async () => {
      const appointment = await getAppointmentById(appointmentId!);
      if (appointment) {
        options.onSuccess?.(appointment);
      }
      return appointment as Appointment;
    },
    ...options,
    enabled,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    isPlaceholderData,
    isEnabled,
  };
}

export default useGetAppointment;
